import { RootState } from 'store/root-reducer';
import { VehicleClassification } from '../types';

export const getVehicleClassifications = (state: RootState): VehicleClassification[] =>
  state.wim.vehicleClassifications.vehicleClassifications;
export const isLoading = (state: RootState): boolean => state.wim.vehicleClassifications.isLoading;
